import isClient from './isClient'

const createStorage = (storage) => ({
  getItem: (key) => {
    try {
      return JSON.parse(storage.getItem(key))
    } catch (e) {
      return storage.getItem(key)
    }
  },
  setItem: (key, value) => {
    try {
      storage.setItem(key, JSON.stringify(value))
    } catch (e) {}
  },

  getDecryptedItem: (key) => {
    try {
      const storageData = storage.getItem(key)

      const string = decodeURIComponent(
        Array.prototype.map
          .call(atob(storageData), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )

      return JSON.parse(string)
    } catch (e) {
      return storage.getItem(key)
    }
  },

  setEncryptedItem: (key, value) => {
    try {
      const string = JSON.stringify(value)
      const base64 = btoa(
        encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, function (_, p1) {
          return String.fromCharCode('0x' + p1)
        })
      )
      return storage.setItem(key, base64)
    } catch (e) {}
  },

  clear: () => {
    return storage.clear()
  }
})

const getSession = () => {
  if (!isClient()) {
    return {
      getItem: () => {},
      setItem: () => {},
      getDecryptedItem: () => {},
      setEncryptedItem: () => {},
      clear: () => {}
    }
  }

  return createStorage(window.sessionStorage)
}

const getLocal = () => {
  if (!isClient()) {
    return {
      getItem: () => {},
      setItem: () => {},
      getDecryptedItem: () => {},
      setEncryptedItem: () => {},
      clear: () => {}
    }
  }

  return createStorage(window.localStorage)
}

export default {
  session: getSession(),
  local: getLocal()
}
